class PKProductMetaVariations extends HTMLElement {
  constructor() {
    super();
    this.list = null;
    this.items = [];
    this.button = null;
    this.expanded = false;
    this.maxVisible = 6; // par défaut (sera remplacé dans connectedCallback)
  }

  connectedCallback() {
    this.maxVisible = parseInt(this.dataset.maxVisible) || 6; 

    this.list = this.querySelector('.pk-product__meta-variations__list');
    if (!this.list) return;

    this.items = Array.from(this.list.querySelectorAll('.pk-product__meta-variations__item'));

    if (this.items.length > this.maxVisible) {
      this.initSeeMore();
    }
  }

  initSeeMore() {
    this.items.forEach((item, index) => {
      if (index >= this.maxVisible) {
        item.style.display = 'none';
      }
    });

    this.button = document.createElement('button');
    this.button.textContent = 'Voir plus';
    this.button.className = 'pk-product__meta-variations__button';
    this.button.addEventListener('click', this.toggleItems.bind(this));

    this.list.appendChild(this.button);
  }

  toggleItems() {
    if (!this.expanded) {
      this.items.forEach(item => {
        item.style.display = '';
      });
      this.button.textContent = 'Voir moins';
      this.expanded = true;
    } else {
      this.items.forEach((item, index) => {
        if (index >= this.maxVisible) {
          item.style.display = 'none';
        }
      });
      this.button.textContent = 'Voir plus';
      this.expanded = false;
    }
  }
}

customElements.define('pk-product-meta-variations', PKProductMetaVariations);